import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { Text } from 'src/components/shared/ui';
import { useAppDispatch, useAppSelector } from 'src/redux';
import { RootReducer } from 'src/redux/modules/types';
import { hideModal } from 'src/redux/modules/ui/actions';

const Modal = ({ ...props }) => {
  const { title, description, open, type, handleConfirm, handleOnClose, confirmButton } =
    useAppSelector((state: RootReducer) => state.ui.modal);
  const dispatch = useAppDispatch();
  const handleClose = () => {
    handleOnClose?.();
    dispatch(hideModal());
  };
  const handleCloseForm = () => {
    dispatch(hideModal());
  };

  return (
    <Dialog
      keepMounted
      onClose={handleClose}
      open={open}
      aria-describedby="alert-dialog-slide-description"
      {...props}
      PaperProps={
        {
          sx: {
            width: '75%',
            maxWidth: '500px',
          },
          'data-testid': 'modal-container-div',
        } as object
      }
    >
      <DialogTitle color="primary">{title}</DialogTitle>
      <DialogContent>
        {typeof description == 'string' ? <Text variant="body1">{description}</Text> : description}
      </DialogContent>
      <DialogActions>
        {(type === 'confirm' || type === 'confirmForm') && (
          <>
            <Button
              data-testid="modal-cancel-btn"
              variant="outlined"
              size="medium"
              onClick={handleClose}
              color="error"
            >
              Cancelar
            </Button>
            <Button
              data-testid="modal-confirm-btn"
              variant="contained"
              size="medium"
              onClick={() => {
                handleConfirm();
                if (type === 'confirmForm') {
                  handleCloseForm();
                } else {
                  handleClose();
                }
              }}
            >
              {confirmButton ?? 'Confirmar'}
            </Button>
          </>
        )}
        {type == 'alert' && (
          <Button
            data-testid="modal-continue-btn"
            variant="contained"
            size="medium"
            onClick={() => {
              handleConfirm?.(), handleClose();
            }}
          >
            {confirmButton ?? 'Continuar'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default Modal;
